<div class="container-fuild">
    <div class="row pt-4 d-flex align-items-center">
        <div class="col-md-8 step-title">
            <h5 class="mb-0">Job Description</h5>
            <p class="mb-0">Enter the Details of the Position</p>
        </div>
        
        <div class="col-md-4 editBtn headerSubPortion px-0"> 
            <ul>
              <li class="col-auto px-0 firstPortion"> 
                <gc-status-update [stepDetails]="stepDetails" type="EDIT"></gc-status-update>
              </li>
              <li class="col-auto pr-0 pl-2 secondPortion">
                <lib-maximize-dialog-library [configData]="{'layoutCode':stepDetails?.stepActionList[0].layoutCode}"></lib-maximize-dialog-library>
            <i (click)="handleClose();" class="close-icon pi pi-times pull-right"></i>
              </li>
            </ul>
          </div>
    </div>
    <div class="row"> 
        <div class="col-md-12 p-0">
            <lib-assigning-task-library  [stepDetails]="stepDetails" (updateStatus)="updateStepStatus($event)">
            </lib-assigning-task-library>
        </div>
    </div>
    <p-divider></p-divider>
    <form (ngSubmit)="postJobDescription()" [formGroup]="jobDescriptionForm">
        <div class="main-body">
            <div class="row mb-3">
                <div class="col-md-4 form-group input-disabled">
                    <label class="label-cls  required"> Job Title </label>
                    <input class="im-input mw-100" [readonly]="disabledControls" formControlName="jobTitle" type="text"
                        pInputText placeholder="Enter" />
                    <div
                        *ngIf="jobDescriptionForm.controls['jobTitle'].touched && jobDescriptionForm.controls['jobTitle'].invalid">
                        <span class="invalid-message" *ngIf="jobDescriptionForm.controls['jobTitle'].errors?.required">
                            {{getGlobalErrorMessages('REQUIRED')}}
                        </span>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-4 form-group">
                    <label class="label-cls  required"> SOC (ONET/OES) Code </label>
                    <p-inputMask mask="99-9999.99" [disabled]="disabledControls" formControlName="socCode" type="text"
                        (onBlur)="getSocCode()" placeholder="Enter"></p-inputMask>
                    <small class="p-error">
                        <span>{{this.titleSoc}}</span>
                    </small>
                    <div
                        *ngIf="jobDescriptionForm.controls['socCode'].touched && jobDescriptionForm.controls['socCode'].invalid">
                        <span class="invalid-message" *ngIf="jobDescriptionForm.controls['socCode'].errors?.required">
                            {{getGlobalErrorMessages('REQUIRED')}}
                        </span>
                    </div>
                </div>
                <div class="col-md-4 form-group input-disabled">
                    <label class="label-cls  required"> SOC (ONET/OES) Occupation Title </label>
                    <input class="im-input mw-100 readonly" readonly formControlName="socTitle" type="text"
                        pInputText />
                    <div
                        *ngIf="jobDescriptionForm.controls['socTitle'].touched && jobDescriptionForm.controls['socTitle'].invalid">
                        <span class="invalid-message" *ngIf="jobDescriptionForm.controls['socTitle'].errors?.required">
                            {{getGlobalErrorMessages('REQUIRED')}}
                        </span>
                    </div>
                </div>
                </div>
                <div class="row mb-3" *ngIf="showLaborInfo">
                <div class="col-md-4 form-group">
                    <label class="label-cls"> Labor Certification DOL Case Number </label>
                    <input class="im-input mw-100" [readonly]="disabledControls" formControlName="laborCertDOLCaseNumber" type="text"
                        pInputText />
                    <div
                        *ngIf="jobDescriptionForm.controls['laborCertDOLCaseNumber'].touched && jobDescriptionForm.controls['laborCertDOLCaseNumber'].invalid">
                        <span class="invalid-message" *ngIf="jobDescriptionForm.controls['laborCertDOLCaseNumber'].errors?.required">
                            {{getGlobalErrorMessages('REQUIRED')}}
                        </span>
                    </div>
                </div>
                <div class="col-md-4 form-group">
                    <label class="label-cls dsplay-blk"> Labor Certification DOL Filing Date </label>
                        <p-calendar styleClass="p-form-datepicker mw-100" appendTo="body" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY"
                         [showIcon]="true" formControlName="laborCertDOLFilingDate"
                        [monthNavigator]="true" [yearNavigator]="true" [showButtonBar]="true" yearRange="1910:2050" >
                      </p-calendar>
                    <div
                        *ngIf="jobDescriptionForm.controls['laborCertDOLFilingDate'].touched && jobDescriptionForm.controls['laborCertDOLFilingDate'].invalid">
                        <span class="invalid-message" *ngIf="jobDescriptionForm.controls['laborCertDOLFilingDate'].errors?.required">
                            {{getGlobalErrorMessages('REQUIRED')}}
                        </span>
                    </div>
                </div>
                <div class="col-md-4 form-group">
                    <label class="label-cls dsplay-blk"> Labor Certification Expiration Date </label>
                        <p-calendar styleClass="p-form-datepicker mw-100" appendTo="body" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY"
                        [showIcon]="true" formControlName="laborCertExpDate"
                       [monthNavigator]="true" yearRange="1910:2050" [yearNavigator]="true" [showButtonBar]="true" [disabled]="disabledControls">
                     </p-calendar>
                    <div
                        *ngIf="jobDescriptionForm.controls['laborCertExpDate'].touched && jobDescriptionForm.controls['laborCertExpDate'].invalid">
                        <span class="invalid-message" *ngIf="jobDescriptionForm.controls['laborCertExpDate'].errors?.required">
                            {{getGlobalErrorMessages('REQUIRED')}}
                        </span>
                    </div>
                </div>
            </div>
            <div class="row col-md-12">
                <h5 class="sub-title">Add Worksite Location</h5>
            </div>
            <div class="row mb-3" formGroupName="address">
                <div class="col-md-4 form-group input-disabled">
                    <label class="label-cls required"> Address Line 1 </label>
                    <input class="im-input mw-100" id="addressLine1" formControlName="addressLine1" type="text"
                        pInputText [readonly]="disabledControls" placeholder="Enter" />
                    <div
                        *ngIf="jobDescriptionForm.get('address.addressLine1').touched && jobDescriptionForm.get('address.addressLine1').invalid">
                        <span class="invalid-message"
                            *ngIf="jobDescriptionForm.get('address.addressLine1').errors?.required">
                            {{getGlobalErrorMessages('REQUIRED')}}
                        </span>
                    </div>
                </div>
                <div class="col-md-4 input-disabled">
                    <label class="label-cls"> Address Line 2 </label>
                    <input class="im-input mw-100" id="addressLine2" formControlName="addressLine2" pInputText
                        type="text" [readonly]="disabledControls" placeholder="Enter" />
                    <div
                        *ngIf="jobDescriptionForm.get('address.addressLine2').touched && jobDescriptionForm.get('address.addressLine2').invalid">
                        <span class="invalid-message"
                            *ngIf="jobDescriptionForm.get('address.addressLine2').errors?.required">
                            {{getGlobalErrorMessages('REQUIRED')}}
                        </span>
                    </div>
                </div>
                <div class="col-md-4 input-disabled processing-dropdown">
                    <label class="label-cls  required"> Country </label>
                    <p-dropdown [options]="countryList" [filter]="false" id="countryCode" formControlName="countryCode"
                        [disabled]="disabledControls" optionLabel="countryName" optionValue="countryCode"
                        (onChange)="handleCountryChange($event.value)" placeholder="select"> </p-dropdown>
                    <div
                        *ngIf="jobDescriptionForm.get('address.countryCode').touched && jobDescriptionForm.get('address.countryCode').invalid">
                        <span class="invalid-message"
                            *ngIf="jobDescriptionForm.get('address.countryCode').errors?.required">
                            {{getGlobalErrorMessages('REQUIRED')}}
                        </span>
                    </div>
                </div>
            </div>
            <div class="row mb-3" formGroupName="address">
                <div class="col-md-4 form-group processing-dropdown" *ngIf="stateList.length > 0">
                    <label class="label-cls  required"> State </label>
                    <p-dropdown [options]="stateList" id="stateProvinceCode" formControlName="stateProvinceCode"
                        [disabled]="disabledControls" name="country" optionLabel="stateProvinceName"
                        optionValue="stateProvinceCode" placeholder="select"> </p-dropdown>
                    <div
                        *ngIf="jobDescriptionForm.get('address.stateProvinceCode').touched && jobDescriptionForm.get('address.stateProvinceCode').invalid">
                        <span class="invalid-message"
                            *ngIf="jobDescriptionForm.get('address.stateProvinceCode').errors?.required">
                            {{getGlobalErrorMessages('REQUIRED')}}
                        </span>
                    </div>
                </div>
                <div class="col-md-4 input-disabled" *ngIf="stateList.length <= 0">
                    <label class="label-cls  required"> State </label>
                    <input class="im-input mw-100" id="stateProvinceName" formControlName="stateProvinceName"
                        type="text" [readonly]="disabledControls" pInputText placeholder="Enter" />
                    <div
                        *ngIf="jobDescriptionForm.get('address.stateProvinceName').touched && jobDescriptionForm.get('address.stateProvinceName').invalid">
                        <span class="invalid-message"
                            *ngIf="jobDescriptionForm.get('address.stateProvinceName').errors?.required">
                            {{getGlobalErrorMessages('REQUIRED')}}
                        </span>
                    </div>
                </div>
                <div class="col-md-4 input-disabled">
                    <label class="label-cls  required"> City </label>
                    <input class="im-input mw-100" id="city" formControlName="city" pInputText type="text"
                        [readonly]="disabledControls" placeholder="Enter" />
                    <div
                        *ngIf="jobDescriptionForm.get('address.city').touched && jobDescriptionForm.get('address.city').invalid">
                        <span class="invalid-message" *ngIf="jobDescriptionForm.get('address.city').errors?.required">
                            {{getGlobalErrorMessages('REQUIRED')}}
                        </span>
                    </div>
                </div>
                <div class="col-md-4 input-disabled">
                    <label class="label-cls required"> Postal Code </label>
                    <input class="im-input" id="postCode" formControlName="postCode" type="text" pInputText
                        [readonly]="disabledControls" placeholder="Enter" />
                    <div
                        *ngIf="jobDescriptionForm.get('address.postCode').touched && jobDescriptionForm.get('address.postCode').invalid">
                        <span class="invalid-message"
                            *ngIf="jobDescriptionForm.get('address.postCode').errors?.required">
                            {{getGlobalErrorMessages('REQUIRED')}}
                        </span>
                    </div>
                </div>
            </div>
            <div class="row col-md-12">
                <h5 class="sub-title">Wage offer Information</h5>
            </div>
            <div class="row mb-3">
                <div class="col-md-4 form-group input-disabled">
                    <label class="label-cls required"> Offered Wage - From </label>
                    <span class="p-input-icon-left mask-input mw-100"> <i class="pi pi-dollar"></i>
                        <input class="im-input mask-in mw-100" id="wagesFrom" formControlName="wagesFrom" type="text"
                            [readonly]="disabledControls" pInputText placeholder="" /> </span>
                    <div
                        *ngIf="jobDescriptionForm.controls['wagesFrom'].touched && jobDescriptionForm.controls['wagesFrom'].invalid">
                        <span class="invalid-message" *ngIf="jobDescriptionForm.controls['wagesFrom'].errors?.required">
                            {{getGlobalErrorMessages('REQUIRED')}}
                        </span>
                        <span class="invalid-message" *ngIf="jobDescriptionForm.controls['wagesFrom'].errors?.pattern">
                            {{getGlobalErrorMessages('NUMBER_ONLY')}}
                        </span>
                    </div>
                </div>
                <div class="col-md-4 input-disabled">
                    <label class="label-cls"> Offered Wage - To </label>
                    <span class="p-input-icon-left mask-input mw-100"> <i class="pi pi-dollar"></i>
                        <input class="im-input mask-in mw-100" id="wagesTo" formControlName="wagesTo" type="text"
                            pInputText [readonly]="disabledControls" placeholder="" /> </span>
                    <div
                        *ngIf="jobDescriptionForm.controls['wagesTo'].touched && jobDescriptionForm.controls['wagesTo'].invalid">
                        <span class="invalid-message" *ngIf="jobDescriptionForm.controls['wagesTo'].errors?.pattern">
                            {{getGlobalErrorMessages('NUMBER_ONLY')}}
                        </span>
                    </div>
                    <div>
                        <span class="invalid-message"
                            *ngIf="jobDescriptionForm.controls['wagesFrom'].value
                        && jobDescriptionForm.controls['wagesTo'].value <=  jobDescriptionForm.controls['wagesFrom'].value">
                            {{getGlobalErrorMessages('WAGES_TO_GREATER')}}
                        </span>
                    </div>
                </div>
                <div class="col-md-4 processing-dropdown">
                    <label class="label-cls  required"> Wage Unit </label>
                    <p-dropdown [options]="wageUnitType" [filter]="false" id="wageTypeCode"
                        formControlName="wageTypeCode" [disabled]="disabledControls" optionLabel="name"
                        optionValue="code" placeholder="select">
                    </p-dropdown>
                    <div
                        *ngIf="jobDescriptionForm.controls['wageTypeCode'].touched && jobDescriptionForm.controls['wageTypeCode'].invalid">
                        <span class="invalid-message"
                            *ngIf="jobDescriptionForm.controls['wageTypeCode'].errors?.required">
                            {{getGlobalErrorMessages('REQUIRED')}}
                        </span>
                    </div>
                </div>
            </div>

            <job-duties [disabledControls]="disabledControls" (deleteAllDutie)="handleDeleteAllDuties()"
                (addUpdateDuty)="handleAddUpdateDuty($event)" [parentForm]="jobDescriptionForm"
                (deleteDuty)="handleDutyDelete($event)" (deleteSubDuty)="handleSubDutyDelete($event)"
                (deleteDutiesOnPopulateDuties)="alldutiesDelete()" [inputData]="dynamicDialogConfig.data"></job-duties>

            <div class="form-group">
                <div class="row col-md-6">
                    <div class="col-md-11 pl-0 bold-label" name="question">
                        <label class="label-cls">Is this a full time position?</label>
                    </div>
                    <div class="col-md-1">
                        <p-inputSwitch id="thisFulltime" [disabled]="disabledControls" formControlName="thisFulltime"
                            (onChange)="handleDataChange($event)">
                        </p-inputSwitch>
                    </div>
                </div>
                <div class="row" *ngIf="jobDescriptionForm.get('thisFulltime').value === false">
                    <div class="col-md-4 form-group input-disabled">
                        <label class="label-cls required"> Working Hours Per Week </label>
                        <input [readonly]="disabledControls" type="text" class="im-input mw-100"
                            id="workingHoursPerWeek" formControlName="workingHoursPerWeek" placeholder="Enter"
                            pattern="\d{1,5}" pInputText />
                        <div
                            *ngIf="jobDescriptionForm.get('workingHoursPerWeek').touched && jobDescriptionForm.get('workingHoursPerWeek').invalid">
                            <span class="invalid-message"
                                *ngIf="jobDescriptionForm.get('workingHoursPerWeek').errors?.required">
                                {{getGlobalErrorMessages('REQUIRED')}}
                            </span>
                            <span class="invalid-message"
                                *ngIf="jobDescriptionForm.get('workingHoursPerWeek').errors?.pattern">
                                {{getGlobalErrorMessages('NUMBER_ONLY')}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row col-md-6 pb-2">
                <div class="col-md-11  form-group pl-0 bold-label">
                    <label class="label-cls">Is this a permanent position?</label>
                </div>
                <div class="col-md-1  form-group">
                    <p-inputSwitch [disabled]="disabledControls" id="thisPermanentPos"
                        formControlName="thisPermanentPos">
                    </p-inputSwitch>
                </div>
            </div>
            <div class="row col-md-6 pb-2">
                <div class="col-md-11  form-group pl-0 bold-label">
                    <label class="label-cls">Is this a new position?</label>
                </div>
                <div class="col-md-1  form-group">
                    <p-inputSwitch [disabled]="disabledControls" id="thisNewPos" formControlName="thisNewPos">
                    </p-inputSwitch>
                </div>
            </div>
        </div>
        <p-divider></p-divider>
        <div class="row pt-3">
            <div class="col-md-2">
                <button pButton type="submit" label="Save" icon="pi pi-save"
                    [ngClass]="jobDescriptionForm.invalid  || disabledControls || !(jobDescriptionForm.get('selectedRaiobtn').value === 0 ||(jobDescriptionForm.get('selectedRaiobtn').value === 1 && (jobDescriptionForm.get('jobRoleJD').value && (jobDescriptionForm.get('jobRoleJD').value !== 'Other' || (jobDescriptionForm.get('jobRoleJD').value === 'Other' && jobDescriptionForm.get('otherJobPosition').value)) && jobDescriptionForm.get('duties').value && jobDescriptionForm.get('duties').value.length > 0))) ? 'btn-success button-width-icon-left mr-3 btn-success_disabled':'btn-success button-width-icon-left mr-3'"
                    [disabled]="jobDescriptionForm.invalid  || disabledControls || !(jobDescriptionForm.get('selectedRaiobtn').value === 0 ||(jobDescriptionForm.get('selectedRaiobtn').value === 1 && (jobDescriptionForm.get('jobRoleJD').value && (jobDescriptionForm.get('jobRoleJD').value !== 'Other' || (jobDescriptionForm.get('jobRoleJD').value === 'Other' && jobDescriptionForm.get('otherJobPosition').value)) && jobDescriptionForm.get('duties').value && jobDescriptionForm.get('duties').value.length > 0)))"></button>
            </div>
            <div class="col-md-2">
                <button pButton type="button" label="Cancel" icon="pi pi-times-circle" class="p-button-secondary cancel-btn button-width-icon-left 
                d-flex alogn-items-center" [disabled]="disabledControls" (click)="handleCancel()">
                </button>
            </div>
            <div class="col-md-2"></div>
            <div class="col-md-6">
                <gc-status-update [stepDetails]="stepDetails" [type]="typeOfButton" (onDiscardUnsavedChanges)="handleCancel()" [showPreviousStepBtn]="showPrev" [showNextStepBtn]="showNext" class="d-flex col-12 justify-content-end"></gc-status-update>
            </div>
        </div>
    </form>
</div>